export default async ({ $api, $cookies, store }) => {
  if (store.getters['user/get']) {
    return;
  }
  await $api('util/sessions/status').then(user => {
    if (user === null) return;

    if (!user.id) {
      user = null;
    }
    store.commit('user/setOptions', {
      showEmailOptin: user ? !user.bonkers_mktg_optin : true,
      showCreateAccount: user ? !user.save_details : true
    });
    if (user) {
      delete user.id;
      store.commit('user/set', user);
      const { supply_address: address } = user;
      store.commit('user/setCustomer', user);
      if (address) {
        store.commit('utils/setAddress', address);
      }
    }
  });
};
